import React from 'react';

interface PrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({ variant = 'primary', children, className = '', ...props }) => {
  const base =
    'rounded-[16px] px-9 py-3 font-medium text-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-blue-600 text-white border border-blue-300 hover:bg-blue-700',
    secondary: 'bg-white text-blue-700 border border-blue-300 hover:bg-blue-50'
  };
  return (
    <button className={`${base} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
};

export default PrimaryButton;
